import { generateInventoryData } from "@p0security/shared/assessment/inventory";
import { InventoryItem } from "@p0security/shared/assessment/inventory";
import {
  AssessmentScope,
  AssessmentScopeIntegration,
  providerToScope,
} from "@p0security/shared/types/assessment";
import { ProviderOrAll } from "@p0security/shared/types/assessment";
import { TargetNodeType } from "@p0security/shared/types/assessment/data/index";
import { flatMap } from "lodash";

export const transformInventoryData = (
  targets: AssessmentScope[],
  provider: ProviderOrAll
): Array<InventoryItem<TargetNodeType> & { category: string }> => {
  if (!targets) return [];

  return flatMap(generateInventoryData(targets), (links, category) =>
    Object.values(links)
      .filter(
        (l: InventoryItem<TargetNodeType>) =>
          l.show !== "resource" || filterResourceLinks(l, provider)
      )
      .map((l) => ({ ...l, category }))
  );
};

// apply specific filtering to resource links
const filterResourceLinks = (
  l: InventoryItem<TargetNodeType>,
  provider: ProviderOrAll
) => {
  const integration = providerToScope(provider) as Exclude<
    AssessmentScopeIntegration,
    "azure-ad"
  >;

  return (
    !l.predicate ||
    l.predicate([
      {
        integration,
        type: "organization",
      },
    ])
  );
};
